// extracted by mini-css-extract-plugin
export default {"image-scroll":"ViewFilesCarousel_image-scroll__k6uvn","video":"ViewFilesCarousel_video__7YBXy","pdf":"ViewFilesCarousel_pdf__yhdUM","list":"ViewFilesCarousel_list__gZene"};